import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9ce3babc")

_pushScopeId("data-v-9ce3babc")
const _hoisted_1 = { class: "body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IndexPage = _resolveComponent("IndexPage")
  const _component_VRPage = _resolveComponent("VRPage")
  const _component_MapPage = _resolveComponent("MapPage")
  const _component_EndPage = _resolveComponent("EndPage")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.page === 1)
      ? (_openBlock(), _createBlock(_component_IndexPage, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.page !== 1)
      ? (_openBlock(), _createBlock(_component_VRPage, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.page === 2)
      ? (_openBlock(), _createBlock(_component_MapPage, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.page === 3)
      ? (_openBlock(), _createBlock(_component_EndPage, { key: 3 }))
      : _createCommentVNode("", true)
  ]))
})